var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.822,
    height: 181.681,
    viewBox: "0 0 174.822 181.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(-731.915 -769.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(251.75 -51.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    d: "M528.979,370.014h-67.62l-33.809,58.56,33.809,58.56h67.62l33.81-58.56Z",
    transform: "translate(691.147 268.677) rotate(60)",
    fill: "none",
    stroke: "#ed3a72",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    strokeDasharray: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M528.979,370.014h-67.62l-33.809,58.56,33.809,58.56h67.62l33.81-58.56Z",
    transform: "translate(-51.165 1126.336) rotate(-60)",
    fill: "#ffe403",
    stroke: "#ed3a72",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    strokeDasharray: 31
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(272.503 625.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2955",
    "data-name": "Path 2955",
    d: "M84.861,103.832l47.716-.181.122,2.511-47.814.217Z",
    transform: "translate(186.077 164.541)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2957",
    "data-name": "Path 2957",
    d: "M167.228,101.919a1.688,1.688,0,0,1,.354,2.429,1.649,1.649,0,0,1-1.917.123q-.133-1.308-.266-2.617A1.79,1.79,0,0,1,167.228,101.919Z",
    transform: "translate(169.682 164.951)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2959",
    "data-name": "Path 2959",
    d: "M161.87,97.545a1.9,1.9,0,0,1,1.464-.362c2.682.726,3.113,11.113,1.123,11.747-.482.154-1.06-.278-1.5-.7Q162.413,102.885,161.87,97.545Z",
    transform: "translate(170.401 165.866)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2961",
    "data-name": "Path 2961",
    d: "M153.032,92.3a5.835,5.835,0,0,1,4.13-.128c5.8,2.276,6.962,17.022,1.969,19.932-.864.5-2.267.86-4.592.176Q153.785,102.291,153.032,92.3Z",
    transform: "translate(172.2 166.942)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2963",
    "data-name": "Path 2963",
    d: "M148.311,92.436c1.065-.807,2.816-1.888,4.411-1.383,5.318,1.681,6.422,20.191,1.407,22.44-1.581.71-3.576-.284-4.964-1.187Q148.738,102.37,148.311,92.436Z",
    transform: "translate(173.161 167.132)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2965",
    "data-name": "Path 2965",
    d: "M146.279,91.083a2.065,2.065,0,0,0-1.793,1.093,1.946,1.946,0,0,0-.191.972q.178,9.273.355,18.546a2.382,2.382,0,0,0,.309,1,2.246,2.246,0,0,0,1.731,1.152,2.525,2.525,0,0,0,1.817-1.06c2.921-3.371,2.241-18.057-.527-20.844A2.5,2.5,0,0,0,146.279,91.083Z",
    transform: "translate(173.979 167.099)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2967",
    "data-name": "Path 2967",
    d: "M62.447,103.069a1.689,1.689,0,0,0-.354,2.43,1.651,1.651,0,0,0,1.917.123L64.275,103A1.79,1.79,0,0,0,62.447,103.069Z",
    transform: "translate(190.788 164.717)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2969",
    "data-name": "Path 2969",
    d: "M67.48,98.693a1.9,1.9,0,0,0-1.464-.362c-2.682.728-3.109,11.114-1.118,11.749.481.153,1.06-.279,1.5-.706Q66.938,104.034,67.48,98.693Z",
    transform: "translate(190.393 165.633)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2971",
    "data-name": "Path 2971",
    d: "M74.93,93.445a5.838,5.838,0,0,0-4.13-.127c-5.8,2.279-6.955,17.025-1.96,19.933.863.5,2.267.859,4.592.173Z",
    transform: "translate(189.98 166.709)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2973",
    "data-name": "Path 2973",
    d: "M79.7,93.577c-1.066-.806-2.817-1.885-4.411-1.38-5.318,1.684-6.414,20.192-1.4,22.44,1.582.709,3.576-.286,4.963-1.189Z",
    transform: "translate(188.967 166.899)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2975",
    "data-name": "Path 2975",
    d: "M82.484,92.224a2.062,2.062,0,0,1,1.793,1.092,1.938,1.938,0,0,1,.192.972q-.174,9.273-.347,18.546a2.382,2.382,0,0,1-.309,1,2.245,2.245,0,0,1-1.731,1.152,2.526,2.526,0,0,1-1.818-1.059c-2.921-3.37-2.248-18.056.519-20.844A2.5,2.5,0,0,1,82.484,92.224Z",
    transform: "translate(187.399 166.867)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2977",
    "data-name": "Path 2977",
    d: "M149.13,114.733a10.24,10.24,0,0,1,4.763,1.113,4.75,4.75,0,0,1,2.485,5.723,9.046,9.046,0,0,1-2.3,3.944,26.918,26.918,0,0,1-8.426,5.9,6.665,6.665,0,0,1-3.946.4q-6.989-1.154-13.973-2.341c-.858-.144-.86-.151-.641-.952a11.359,11.359,0,0,0-.078-5.929c-.075-.29-.118-.473.221-.619,5.5-2.373,10.941-4.921,16.743-6.527A20.249,20.249,0,0,1,149.13,114.733Z",
    transform: "translate(177.506 162.285)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2979",
    "data-name": "Path 2979",
    d: "M73.985,114.738a28.336,28.336,0,0,1,9.2,2.1c4.083,1.5,8.057,3.261,12.032,5.024.452.2.547.393.409.877a10.551,10.551,0,0,0-.014,5.98c.147.5.022.64-.459.719-4.767.789-9.528,1.6-14.292,2.4a6.786,6.786,0,0,1-4.23-.612,24.769,24.769,0,0,1-8.822-6.743,7.975,7.975,0,0,1-1.36-2.616,4.889,4.889,0,0,1,2.9-6.265A11.261,11.261,0,0,1,73.985,114.738Z",
    transform: "translate(189.879 162.284)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2981",
    "data-name": "Path 2981",
    d: "M121.369,126.342a10.083,10.083,0,0,1-4.186,8.073,7.781,7.781,0,0,1-8.3.135,9.77,9.77,0,0,1-2.357-13.936,5.971,5.971,0,0,1,2.1-1.764,9.547,9.547,0,0,1,8.048-.352C120.1,119.939,121.174,122.954,121.369,126.342Z",
    transform: "translate(182.062 161.667)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2983",
    "data-name": "Path 2983",
    d: "M108.871,106.931a9.329,9.329,0,0,0-6.337-3.223,6.4,6.4,0,0,1-.784-.093.743.743,0,0,1-.671-.835c.055-.444.411-.6.824-.588a11.156,11.156,0,0,1,3.788.781,10.806,10.806,0,0,1,4.5,3.234.753.753,0,0,0,.778.308,10.664,10.664,0,0,1,2.5,0,.938.938,0,0,0,.95-.375,10.812,10.812,0,0,1,7.909-3.918c.088-.006.176-.01.264-.01.455,0,.882.121.9.652.012.494-.358.721-.821.778-.566.07-1.137.108-1.7.205a8.583,8.583,0,0,0-5.292,3.127,8.255,8.255,0,0,1,2.589,1.631,5.184,5.184,0,0,1,1.547,4.987,3.074,3.074,0,0,1-.3.8c-.44.824-.648.847-1.446.389a10.993,10.993,0,0,0-11.574.017c-.8.453-.985.466-1.416-.366a4.635,4.635,0,0,1,.132-4.427C105.894,108.651,106.8,107.925,108.871,106.931Z",
    transform: "translate(182.777 164.838)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2985",
    "data-name": "Path 2985",
    d: "M139.313,145.283a13,13,0,0,1-8.042-3.073,54.45,54.45,0,0,1-5.724-5.535.7.7,0,0,1-.084-.975c.552-.927.529-.942,1.59-.764q6.524,1.1,13.048,2.2A5.27,5.27,0,0,1,143.831,141a3.78,3.78,0,0,1-3.36,4.156C140.02,145.239,139.556,145.257,139.313,145.283Z",
    transform: "translate(177.844 158.191)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2987",
    "data-name": "Path 2987",
    d: "M86.536,145.281a5.046,5.046,0,0,1-3.8-1.344,3.4,3.4,0,0,1-.663-4.013,5.025,5.025,0,0,1,3.7-2.88c4.376-.735,8.755-1.447,13.129-2.193.448-.076.7-.014.852.427a2.892,2.892,0,0,0,.342.636.461.461,0,0,1-.067.639,37.318,37.318,0,0,1-7.016,6.55A12.24,12.24,0,0,1,86.536,145.281Z",
    transform: "translate(186.723 158.196)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2989",
    "data-name": "Path 2989",
    d: "M121.06,146.967a13.289,13.289,0,0,1,.749,4.775.94.94,0,0,1-.4.71,10.036,10.036,0,0,1-4.989,2.236,17.407,17.407,0,0,1-9.791-.728c-2.7-1.037-3.155-1.867-2.689-4.732a16.509,16.509,0,0,1,.436-1.926c.074-.253.14-.413.427-.163,2.778,2.428,6.126,2.753,9.6,2.537a12.071,12.071,0,0,0,4.384-1.109A7.755,7.755,0,0,0,121.06,146.967Z",
    transform: "translate(182.226 155.723)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2991",
    "data-name": "Path 2991",
    d: "M121.784,155.582a12.142,12.142,0,0,1-1.7,5.671,1.2,1.2,0,0,1-.587.405,16.082,16.082,0,0,1-8.751,1.252,11.956,11.956,0,0,1-4.728-1.3c-.171-.094-.373-.146-.477-.334a13.561,13.561,0,0,1-1.7-5.645C109.86,158.851,115.8,158.964,121.784,155.582Z",
    transform: "translate(182.211 153.97)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2993",
    "data-name": "Path 2993",
    d: "M113.145,147.272a15.59,15.59,0,0,1-4.982-.8,5.992,5.992,0,0,1-2.378-1.489.839.839,0,0,1-.185-1.109,8.933,8.933,0,0,1,2.358-2.964.708.708,0,0,1,.874-.092,9.575,9.575,0,0,0,8.683-.046.6.6,0,0,1,.75.082,8.152,8.152,0,0,1,2.484,3.1.731.731,0,0,1-.148.935,7.266,7.266,0,0,1-3.864,1.98A15.042,15.042,0,0,1,113.145,147.272Z",
    transform: "translate(181.882 157.004)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2995",
    "data-name": "Path 2995",
    d: "M99,161.087c-.219.511.025.878.136,1.266-.566.069-.479.566-.565.916a21.929,21.929,0,0,1-1.212,3.409c-.093.215-.165.572-.4.534-.277-.044-.265-.4-.274-.661,0-.107-.015-.213-.023-.314a.52.52,0,0,0-.088-.015c-.33.025-.659.55-.911.217-.2-.258.3-.514.49-.756a10.75,10.75,0,0,0,1.95-5.249c.034-.217.063-.435.091-.652a1.5,1.5,0,0,0-.532-1.688,4.305,4.305,0,0,1-1.239-3.038A16.155,16.155,0,0,1,96.479,150a.946.946,0,0,0-.064-.571,2.527,2.527,0,0,1,.235-2.515,27.179,27.179,0,0,1,4.865-5.431,2.488,2.488,0,0,1,1.3-.608c.338-.046.7-.026.831.356a.737.737,0,0,1-.328.861,1.366,1.366,0,0,1-.4.232,2.311,2.311,0,0,0-1.5,1.63c-.379,1.1-.741,2.206-1.117,3.308-.389,1.136-.8,2.252-2.076,2.72-.36.131-.106.366-.022.532.507,1,1.042,1.983,1.536,2.987a9.555,9.555,0,0,1,.788,2.3,2.265,2.265,0,0,1-.623,2.181,1.04,1.04,0,0,0-.287,1c.091.718.132,1.443.172,2.166.01.18.1.444-.131.525-.18.063-.28-.171-.4-.289C99.184,161.306,99.117,161.222,99,161.087Z",
    transform: "translate(183.889 156.967)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2997",
    "data-name": "Path 2997",
    d: "M131.522,166.1c-.027.441.061.855-.287,1.155-.3-.148-.346-.455-.458-.706a21.328,21.328,0,0,1-1.2-3.552c-.056-.224.064-.605-.424-.578-.162.009-.07-.209.006-.306.214-.274.136-.584.151-.92-.353.055-.4.479-.8.535a9.444,9.444,0,0,1,.056-2.639,1.3,1.3,0,0,0-.331-1.174,2.158,2.158,0,0,1-.539-1.956,16.019,16.019,0,0,1,1.846-4.632c.1-.194.194-.4.315-.579.288-.434.339-.723-.268-.973a2.584,2.584,0,0,1-1.313-1.588c-.426-1.105-.794-2.234-1.2-3.349-.157-.433-.345-.855-.512-1.284a1.905,1.905,0,0,0-1.158-1.184,1.985,1.985,0,0,1-.411-.206c-.332-.217-.607-.507-.444-.925.175-.447.575-.386.958-.292a4.082,4.082,0,0,1,1.848,1.1A38.27,38.27,0,0,1,131.2,146.3a2.874,2.874,0,0,1,.537,3.244,1.1,1.1,0,0,0,.012.709,14.45,14.45,0,0,1-.257,6.207,2.9,2.9,0,0,1-1.377,2c-.208.106-.193.268-.176.444.246,2.561.644,5.069,2.43,7.106.1.117.331.238.17.432-.137.165-.331.045-.486-.028S131.752,166.238,131.522,166.1Z",
    transform: "translate(178.007 156.963)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2999",
    "data-name": "Path 2999",
    d: "M107.194,164.986a17.95,17.95,0,0,0,12.706-.032c-.387.568-.663,1-.962,1.409a14.14,14.14,0,0,1-3.561,3.57,4.985,4.985,0,0,0-1.506,2.035c-.087.163-.1.413-.366.407s-.28-.249-.349-.421a4.517,4.517,0,0,0-1.768-2.21A14.5,14.5,0,0,1,107.194,164.986Z",
    transform: "translate(181.53 152.062)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3001",
    "data-name": "Path 3001",
    d: "M134.417,105.936c.3.315.086.581.04.855.4-.013.968-.38,1.12.1.131.417-.532.458-.847.633a5.491,5.491,0,0,0-2.111,1.935c-.307.5-.627.978-.283,1.63a1.469,1.469,0,0,1-.046,1.1,5.546,5.546,0,0,1-.573,1.254c-.737,1.191-1.723,2.195-2.487,3.375a4.923,4.923,0,0,1-2.6,1.712c-.28.1-.628.35-.9-.022a1.158,1.158,0,0,1-.238-1.332,4.227,4.227,0,0,1,2.43-2,.716.716,0,0,0,.568-.66,9.877,9.877,0,0,1,.939-3.208c.345-.653.746-1.258,1.589-1.32.294-.022.306-.287.394-.47A10.587,10.587,0,0,1,134.417,105.936Z",
    transform: "translate(177.832 164.076)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3003",
    "data-name": "Path 3003",
    d: "M93.154,106.846c-.013-.322-.276-.605-.016-.753.221-.127.432.153.605.3a9.325,9.325,0,0,1,2.542,3.234c.077.174.1.381.368.4.918.052,1.3.74,1.62,1.448a11.745,11.745,0,0,1,.815,3.042.716.716,0,0,0,.582.663,4.172,4.172,0,0,1,2.393,1.945,1.1,1.1,0,0,1-.184,1.327c-.313.431-.683.183-1.005.057a5.449,5.449,0,0,1-3.262-2.785,2.218,2.218,0,0,0-.4-.516,8.943,8.943,0,0,1-1.692-2.493,2.158,2.158,0,0,1-.057-1.964.618.618,0,0,0-.057-.619,5.112,5.112,0,0,0-2.063-2.327c-.358-.211-.73-.4-1.094-.6-.112-.063-.266-.123-.229-.281.033-.139.172-.182.311-.2A1.553,1.553,0,0,1,93.154,106.846Z",
    transform: "translate(184.62 164.05)",
    fill: "#ed3a72"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4764",
    "data-name": "Path 4764",
    d: "M-44.239-3.814h2.55V-7.926h4.077v4.111h2.533V-14.223h-2.533v4.094h-4.077v-4.094h-2.55Zm10.825,0h2.55V-7.926h4.077v4.111h2.533V-14.223h-2.533v4.094h-4.077v-4.094h-2.55Zm14.763.347h.33l2.481-6,2.567,6h.347l4.337-10.756h-2.654l-1.908,4.892-2.082-4.892H-17.87l.659,1.648-1.266,3.261-2.1-4.909h-2.672Zm14.9-5.551A5.459,5.459,0,0,0,1.889-3.467,5.91,5.91,0,0,0,6.3-5.376L4.6-7.041A3.868,3.868,0,0,1,1.889-5.879a2.984,2.984,0,0,1-3.053-3.14,2.984,2.984,0,0,1,3.053-3.14A3.868,3.868,0,0,1,4.6-11l1.752-1.665A5.811,5.811,0,0,0,1.889-14.57,5.459,5.459,0,0,0-3.749-9.019Zm10.912,0a5.43,5.43,0,0,0,5.6,5.551,5.44,5.44,0,0,0,5.6-5.551,5.44,5.44,0,0,0-5.6-5.551A5.43,5.43,0,0,0,7.163-9.019Zm2.585,0a2.956,2.956,0,0,1,3.019-3.14,2.966,2.966,0,0,1,3.019,3.14,2.966,2.966,0,0,1-3.019,3.14A2.956,2.956,0,0,1,9.747-9.019Zm9.09,4.268a1.144,1.144,0,0,0,1.249,1.2,1.144,1.144,0,0,0,1.249-1.2,1.144,1.144,0,0,0-1.249-1.2A1.144,1.144,0,0,0,18.838-4.751Z",
    transform: "translate(830.777 829.667)",
    fill: "#ed3a72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.65048be466efe95e1f7792699360adcc.svg";
export { ForwardRef as ReactComponent };